// extracted by mini-css-extract-plugin
export default {"container":"QuienesSomos_container__mheZr","section":"QuienesSomos_section__ScC04","title":"QuienesSomos_title__PdnqB","text":"QuienesSomos_text__w0fPk"};